import axios from "../../http/axios";
import * as actionTypes from "./actionTypes";
export const GET_DRIVERS_SETTLEMENT = "GET_DRIVERS_SETTLEMENT";
export const GET_SEARCH_DRIVERS_SETTLEMENT = "GET_SEARCH_DRIVERS_SETTLEMENT";
export const POST_DRIVERS_SETTLEMENT = "POST_DRIVERS_SETTLEMENT";

export function getDriversSettlement(token, page, id, from, to) {
  const request = axios.get(
    `/reports-settlement/?page=${page}&${from ? `from_date=${from}` : ""}${
      to ? `&to_date=${to}` : ""
    }search=${id}`,
    {
      headers: { Authorization: "JWT " + token }
    }
  );
  return dispatch =>
    request
      .then(res => {
        return dispatch({
          type: GET_DRIVERS_SETTLEMENT,
          payload: res.data
        });
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
}
export function getSearchDriversSettlement(token, page, id, from, to) {
  const request = axios.get(
    `/reports-settlement/?page=${page}&${from ? `from_date=${from}` : ""}${
      to ? `&to_date=${to}` : ""
    }&search=${id}`,
    {
      headers: { Authorization: "JWT " + token }
    }
  );
  return dispatch =>
    request
      .then(res => {
        return dispatch({
          type: GET_SEARCH_DRIVERS_SETTLEMENT,
          payload: res.data
        });
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
}

export function createDriversSettlement(token, data) {
  console.log("my data", data);
  const request = axios.post(`/reports-settlement/`, data, {
    headers: { Authorization: "JWT " + token }
  });

  return dispatch =>
    request
      .then(res => {
        return dispatch({
          type: POST_DRIVERS_SETTLEMENT,
          payload: res
        });
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
}
// /reports-settlement/29/



// WEBPACK FOOTER //
// ./src/store/actions/reportsSettlement.js